@import (reference) '../../../constants/spacing.module.less';

.order-details-side-panel {
  height: 100%;
  width: 264px;
  overflow-y: auto;
  border-right: solid 1px var(--default--border-color--10);
}

.order-details-padded-side-panel {
  height: 100%;
  width: 264px;
  overflow-y: auto;
  padding: @space-16;
  border-right: solid 1px var(--default--border-color--10);
}
